// Vite doesn't define window as global,
// Using type assertion to handle the non-standard global property
;(window as typeof window & { global?: typeof window }).global ||= window

export {}
